let base = require('js-base64').Base64;
const hostname = window.location.hostname
const port = window.location.port;

let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
let env = window.location.port ? 'testing3' : '';
envArr.forEach(d => {
  if (window.location.hostname.includes(d)) {env = d}
})

let API = env ? `${window.location.protocol}//hrss-api.${env}.wdeduc.com` : `${window.location.protocol}//hrss-api.wdeduc.com`;

// const host =  port ? 'wdn-h5.testing3.svc.k8s.bjo.wdcloud.cc:1024' : hostname;
const host =  port ? 'zdy.m-wd.fat.wdeduc.com' : hostname;
const confUrl = base.encode(host);
// API = 'https://hrss-api.testing3.wdeduc.com'//临时访问UAT环境的接口

export default {
    API,
    host,
    confUrl,
};
